// ─── World Grid ───
// GRID_SIZE chosen so (GRID_SIZE - 1) % 3 === 0, keeping roads on the city edge.
// 37 × 37 = 1369 tiles, ~5.35× the original 16 × 16 layout.
export const TILE_SIZE = 4;
export const GRID_SIZE = 37;
export const HALF_GRID = GRID_SIZE / 2;
export const CITY_EXTENT = HALF_GRID * TILE_SIZE;
export const KENNEY_SCALE = 4;

// ─── Forest ───
export const FOREST_INNER_RADIUS = CITY_EXTENT + 2;
export const FOREST_OUTER_RADIUS = 185;
export const FOREST_TREE_COUNT = 1050;
export const FOREST_BUSH_COUNT = 750;
export const FOREST_ROCK_COUNT = 195;
export const FOREST_GRASS_COUNT = 1800;
export const POISSON_MIN_DISTANCE = 3;
export const FOREST_SEED = 42;

// ─── Character ───
export const WALK_SPEED = 5;
export const RUN_SPEED = 16;
export const JUMP_FORCE = 10;
export const GRAVITY = -25;
export const GROUND_Y = 0;
export const CHAR_RADIUS = 0.5;
export const CHAR_HEIGHT = 2.0;

// ─── Camera ───
export const CAM_DISTANCE = 7;
export const CAM_HEIGHT = 3;
export const CAM_MIN_POLAR = 10 * (Math.PI / 180); // 10 deg
export const CAM_MAX_POLAR = 80 * (Math.PI / 180); // 80 deg
export const CAM_FOLLOW_SPEED = 12;
export const CAM_ORBIT_SPEED = 0.003;

// ─── Environment ───
export const FOG_DENSITY = 0.008;
export const AMBIENT_INTENSITY = 0.6;
export const SUN_INTENSITY = 1.2;
export const SHADOW_MAP_SIZE = 2048;
export const SHADOW_AREA = 30;

// ─── Performance ───
// Guarded so this module is importable under node (Vitest test runner has no window global).
const _devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;
export const MOBILE_PIXEL_RATIO = Math.min(_devicePixelRatio, 2);
export const DESKTOP_PIXEL_RATIO = Math.min(_devicePixelRatio, 2);
export const MOBILE_FPS = 30;
export const DESKTOP_FPS = 60;
export const LOD_DISTANCE = 20;

// ─── Animation ───
export const CROSSFADE_DURATION = 0.2;
export const IDLE_THRESHOLD = 0.1;
export const WALK_THRESHOLD = 3;
// Above WALK_THRESHOLD = run

// ─── Asset Paths ───
export const ASSET_BASE = './assets';
export const ROAD_PATH = `${ASSET_BASE}/kenney_city-kit-roads/Models/GLB format`;
export const COMMERCIAL_PATH = `${ASSET_BASE}/kenney_city-kit-commercial_2.1/Models/GLB format`;
export const INDUSTRIAL_PATH = `${ASSET_BASE}/kenney_city-kit-industrial_1.0/Models/GLB format`;
export const SUBURBAN_PATH = `${ASSET_BASE}/kenney_city-kit-suburban_20/Models/GLB format`;
export const FOREST_PATH = `${ASSET_BASE}/Forest-Nature/Assets/gltf`;
export const CHARACTER_PATH = `${ASSET_BASE}/Meshy_AI_biped`;
export const CAR_PATH = `${ASSET_BASE}/kenney_car-kit/Models/GLB format`;
export const NPC_CHARACTER_PATH = `${ASSET_BASE}/kenney_mini-characters/Models/GLB format`;
